const binding = { modules: {}, dataActions: {} };

    (binding.modules['promo-banner'] = {
        c: () => require('@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'promo-banner',
        p: 'promo-banner',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|moenzcsitetheme|views|promo-banner'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/promo-banner.view.tsx'),
                cn: '__local__-__local__-promo-banner'
            };
viewDictionary['__local__|__local__|themes|moetwksitetheme|views|promo-banner'] = {
                c: () => require('partner/themes/moetwksitetheme/views/promo-banner.view.tsx'),
                cn: '__local__-__local__-promo-banner'
            };
viewDictionary['@msdyn365-commerce-modules|promo-banner|modules|promo-banner|promo-banner'] = {
                c: () => require('@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner.view.js'),
                cn: '@msdyn365-commerce-modules-promo-banner-promo-banner'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };